module.exports = __webpack_public_path__ + "static/media/Meda - Ind.Blue_Peri.e7be744f.jpg";